module.exports = __webpack_public_path__ + "static/media/emoji.264a11e0.png";